import {
  DoubleSide,
  MeshStandardMaterial,
  type MeshStandardMaterialParameters,
} from "three";

// Aluminium (profiles / angle sections): smoother and more reflective than the
// matte sheet metal used for corners and other parts, to increase visual
// contrast between part types.
// Roughness is in the range real anodised extrusion sits in; going smoother
// turns the parts into mirrors of a 1k environment map, which reads as noise
// rather than as polish.
// Metalness is 1, not the 0.9 it used to be: a metal has no diffuse term, and
// the 10% that was left mixed a flat grey under every reflection, which read
// as a haze over the profiles. The colour is the reflectance tint alone now.
// Single source of truth for both the raw material and the JSX component.
export const ALUMINUM_MATERIAL_PARAMS: MeshStandardMaterialParameters = {
  color: "#f6f6f6",
  metalness: 1,
  roughness: 0.22,
  side: DoubleSide,
};

export const getRawAluminumMaterial = () =>
  new MeshStandardMaterial(ALUMINUM_MATERIAL_PARAMS);

export const AluminumMaterial = () => (
  <meshStandardMaterial {...ALUMINUM_MATERIAL_PARAMS} />
);
